"use client";

import { tokenService } from "./TokenService";
import { redirectToLoginIfNeeded } from "./authRedirect";

export type AuthRedirectReason = "invalid" | "expired" | "unverified" | "blocked";

function resolveAuthReasonFromCode(code?: string | null): AuthRedirectReason {
  if (!code) {
    return "invalid";
  }

  if (code === "AUTH_UNVERIFIED") {
    return "unverified";
  }

  if (code === "AUTH_EXPIRED") {
    return "expired";
  }

  if (code === "ACCOUNT_BLOCKED") {
    return "blocked";
  }

  return "invalid";
}

/**
 * Clears cached auth data and redirects to the login page
 * when the API responds with an unauthorized status.
 */
export function handleUnauthorizedResponse(
  reason: AuthRedirectReason = "invalid"
): void {
  if (typeof window === "undefined") {
    return;
  }

  tokenService.clearToken();
  redirectToLoginIfNeeded(reason);
}

export function handleProjectAuthError(code?: string): void {
  handleUnauthorizedResponse(resolveAuthReasonFromCode(code));
}
